import React, { useState } from 'react';
import { client } from '../client';

export default function RedeemRequest({ userId, currentCoins }) {
  const [amount, setAmount] = useState('');
  const [payoutDetails, setPayoutDetails] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleRequest = async () => {
    const coinAmount = parseInt(amount, 10);
    if (!coinAmount || coinAmount <= 0 || coinAmount > currentCoins) {
      alert('Enter a valid coin amount.');
      return;
    }

    if (coinAmount < 1000) {
      alert('You need at least 1000 coins to redeem.');
      return;
    }

    if (!payoutDetails.trim()) {
      alert('Please enter payout details.');
      return;
    }

    setLoading(true);

    try {
      await client.create({
        _type: 'redeemRequest',
        userId: { _type: 'reference', _ref: userId },
        amount: coinAmount,
        payoutDetails: payoutDetails.trim(),
        status: 'pending',
        requestedAt: new Date().toISOString()
      });
      setAmount('');
      setPayoutDetails('');
      setShowModal(true);
    } catch (error) {
      console.error('Failed to submit request:', error);
      alert('Something went wrong.');
    }

    setLoading(false);
  };

  const rupees = Math.floor(parseInt(amount || 0) / 100); 

  return (
    <div className="mt-4 space-y-4">
      <p className="text-sm text-gray-600 dark:text-gray-300">
        Minimum <strong>1000 coins</strong> required to redeem. <br />
        <strong>1000 coins = ₹10</strong>
      </p>

      <input
        type="number"
        placeholder="Enter coin amount"
        className="w-full px-3 py-2 border rounded text-gray-900"
        value={amount}
        onChange={(e) => setAmount(e.target.value)}
      />

      {amount && parseInt(amount) >= 1000 && (
        <p className="text-sm text-green-600 dark:text-green-400">
          You will receive: <strong>₹{rupees}</strong>
        </p>
      )}

      <input
        type="text"
        placeholder="Enter payout details (e.g., UPI ID or PayPal)"
        className="w-full px-3 py-2 border rounded text-gray-900"
        value={payoutDetails}
        onChange={(e) => setPayoutDetails(e.target.value)}
      />

      <button
        onClick={handleRequest}
        disabled={loading}
        className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded w-full transition disabled:opacity-50"
      >
        {loading ? 'Submitting...' : 'Request Redemption'}
      </button>

      {/* Confirmation Modal */}
      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-lg text-center">
            <h2 className="text-xl font-semibold mb-2">Request Submitted</h2>
            <p className="mb-4">Your redemption request has been sent and is pending approval.</p>
            <button
              className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
              onClick={() => setShowModal(false)}
            >
              OK
            </button>
          </div>
        </div>
      )}
    </div>
  );
}